import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";

export const useAgendamentoPorId = (uuid: string) => {
  const query = useQuery({
    queryKey: ["agendamento-por-id", uuid],
    queryFn: () => Agendamento.getById({ uuid }),
    select: (response) => response.data,
    enabled: !!uuid,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
